import { AppearanceProvider } from "@web/theme/AppearanceProvider";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { SnackbarProvider } from "notistack";
import { useState, type PropsWithChildren } from "react";
import { AuthProvider } from "@features/auth/context/AuthContext";
import { BusinessConfigProvider } from "@web/config/business-config";

export function AppProviders({ children }: PropsWithChildren) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false },
        },
      }),
  );
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <AppearanceProvider>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <SnackbarProvider
              maxSnack={3}
              autoHideDuration={4000}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            >
              <BusinessConfigProvider>{children}</BusinessConfigProvider>
            </SnackbarProvider>
          </LocalizationProvider>
        </AppearanceProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}
